<div class="container">
  <div class="row mt-3 g-0">
    <div class="col-6 col-md-4">

    </div>

    <div class="col-md-8 col-6">
      <div class="d-flex align-items-center justify-content-end">
        <button class="btn  btn-danger fs-sm d-none d-md-block d-lg-block" *ngIf="buzzNotification !== null"
          (click)="open(content)">A customer needs your
          attention <i class="fa fa-solid fa-bolt"></i>
        </button>
        <a [routerLink]="['/wallet-history']" class="btn btn-clear ms-2">
          <img src="icons/wallet.svg" width="25" height="25" class="img-fluid" alt="Wallet">
        </a>
        <a [routerLink]="['/notifications']" class="btn btn-clear ms-2">
          <img src="icons/notifications.svg" width="25" height="25" class="img-fluid" alt="Notification">
        </a>
        <a [routerLink]="['/profile']">
          <div class="img">
            <img src="icons/waiter.svg" class="img-fluid" alt="Waiter">
          </div>
        </a>
      </div>
    </div>
    <div class="col-md-12 d-block d-md-none d-lg-none mt-3" *ngIf="buzzNotification !== null">
      <button class="btn  btn-danger w-100" (click)="open(content)">A customer needs your
        attention <i class="fa fa-solid fa-bolt"></i>
      </button>
    </div>
  </div>
  <button class="btn btn-sm btn-clear" (click)="goBack()"><img src="icons/back.svg" width="35" height="35" class="img-fluid" alt="Back"></button>
  <h3 class="balance-amount mt-3">
    Wallet
  </h3>
  <div class="mt-3">
    <div class="row">
      <div class="col-md-3">
        <div class="balance-card mt-3 py-3 pl-3">
          <p class="balance-text">
            Balance
          </p>
          <h3 class="balance-amount">
            35,000.00
          </h3>
        </div>
      </div>
      <div class="col-md-3">
        <div class="balance-card mt-3 py-3 pl-3">
          <p class="balance-text">
            Cash
          </p>
          <h3 class="balance-amount">
            35,000.00
          </h3>
        </div>
      </div>
      <div class="col-md-3">
        <div class="balance-card mt-3 py-3 pl-3">
          <p class="balance-text">
            Transfer
          </p>
          <h3 class="balance-amount">
            35,000.00
          </h3>
        </div>
      </div>
      <div class="col-md-3">
        <div class="balance-card mt-3 py-3 pl-3">
          <p class="balance-text">
            Card (POS)
          </p>
          <h3 class="balance-amount">
            35,000.00
          </h3>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5">
    <h3 class="balance-amount">
      Wallet Transaction History
    </h3>
    <div class="row">
      <div class="col-md-4">
        <!-- Search Bar -->
        <div class="input-group my-1 mb-2">
          <div class="search-box">
            <input type="text" placeholder="Search" />
            <button>
              <img src="icons/search.svg" alt="">
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-2">
        <button type="button" class="btn btn-outline-secondary btn-lg status-filter" id="dropdownBasic1"
          ngbDropdownToggle>
          Status &nbsp;&nbsp;&nbsp; <img src="icons/filter.svg" height="20" width="20" alt="">
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="p-2">
          <button ngbDropdownItem class="p-2">Order-fulfilled</button>
          <button ngbDropdownItem class="p-2">Order In Progress</button>
        </div>
      </div> -->
    </div>
    <div class="table-responsive mt-4">
      <table class="table table-bordered table-striped align-middle">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>0034564324</td>
            <td>8,847.67</td>
            <td>
              <span class="status-indicator bg-success"></span> Successful
            </td>
            <td>25-07-2025 2:51 AM</td>
          </tr>
          <tr>
            <td>5605291857</td>
            <td>1,438.28</td>
            <td>
              <span class="status-indicator bg-success"></span> Successful
            </td>
            <td>25-07-2025 2:51 AM</td>
          </tr>
          <tr>
            <td>2199549863</td>
            <td>2,003.94</td>
            <td>
              <span class="status-indicator bg-danger"></span> Failed
            </td>
            <td>25-07-2025 2:51 AM</td>
          </tr>
          <!-- Add more rows as needed -->
        </tbody>
      </table>
    </div>
  </div>

</div>


<ng-template let-modal #content>
  <div class="modal-body p-5 relative">
    <div class="absolute">
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="text-center">
      <h3>Customer Buzz</h3>
      <p>
        {{ buzzNotification && buzzNotification.table }} just buzzed a waiter for reason <b>{{ buzzNotification &&
          buzzNotification.reason }}</b>
      </p>
    </div>

    <div class="text-center mt-3">
      <button class="btn btn-primary btn-lg btn-block" (click)="settime(content2)">Set Wait Time</button>
      <button class="btn btn-outline-secondary btn-lg btn-block mt-3 fw-bold">Chat Customer</button>
    </div>
  </div>
</ng-template>

<ng-template let-modal #content2>
  <div class="modal-body relative">
    <div class="absolute">
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="text-center">
      <h3>Wait Time</h3>
      <p>
        Set a wait time
      </p>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div class="minus">
        <button class="btn btn-primary" (click)="minus()">-</button>
      </div>
      <div class="minutes border border-1">
        {{ minutes }}
      </div>
      <div class="plus">
        <button class="btn btn-primary" (click)="plus()">+</button>
      </div>
    </div>
    <div class="mt-2 text-center">
      <p>Minutes</p>
    </div>

    <div class="text-center mt-5">
      <button class="btn btn-primary btn-lg btn-block">Done</button>
    </div>
  </div>
</ng-template>
